import React, { useState } from "react";
import { isMobileView } from "./CommonFunctions";
import Icon from "../../assets/icons/Icon";

const PageSection = ({ title, children,showInfoIcon,infoText,tooltipPosition,tooltipOffset,tooltipWidth,performParentOnclick }) => {
  const [showInfoText,setShowInfoText]=useState(false);
  return (
    <div className=" bg-white relative  w-full p-4 rounded-lg ">
      {title &&
      <div className="flex items-center"> <h4 
       style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}
          className="text-[16px] mb-1 text-[#000000] tracking-widest"
      >{title} </h4>     
           {showInfoIcon && (
            <div className="relative inline-flex group">
              <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{performParentOnclick ? performParentOnclick() : setShowInfoText(true)}} onMouseLeave={()=>{performParentOnclick ? performParentOnclick() : setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                i
              </span>
{(showInfoText && infoText) && (
  <div
    className={`
      z-50 px-3 py-2 rounded whitespace-normal
      ${isMobileView()
        ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
        : `
          absolute bg-[#4A1E73] text-[#FFFFFF] 
          ${getTooltipPositionClasses(tooltipPosition)}
          ${tooltipOffset ? `m-${tooltipOffset}` : ""}
        `
      }
    `}
    style={{
      width: isMobileView() ? "100%" : tooltipWidth || undefined,
    }}
  >
    {isMobileView() && (
      <span
        className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          setShowInfoText(false);
        }}
        aria-label="Close tooltip"
      >
        <span className="w-4">
          <Icon type="remove" />
        </span>
      </span>
    )}
    {infoText}
  </div>
)}

            </div>
          )}
          </div>}
      <div className={`${title && "mt-3"}`}>{children}</div>
    </div>
  );
};
const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
  }
};
export default PageSection;

// import React from "react";

// const PageSection = ({ title, children,showInfoIcon,onInfoIconClick,infoText,tooltipPosition,tooltipOffset,tooltipWidth,showOnHover }) => {
//   return (
//     <div className=" bg-white relative  w-full p-4 rounded-lg ">
//       {title &&
//       <div className="flex justify-between"> <h4 
//        style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}
//           className="text-[16px] mb-1 text-[#000000] tracking-widest"
//       >{title} </h4>      {showInfoIcon && (
//             <div className="relative inline-flex group">
//               <span className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer" onClick={onInfoIconClick}  onMouseEnter={showOnHover ? onInfoIconClick : undefined}>
//                 i
//               </span>

//              {!showOnHover && <div 
//                 className={`
//                   absolute z-50
//                   invisible group-hover:visible
//                   bg-[#4A1E73] text-[#FFFFFF] px-3 py-2 rounded   
//                   whitespace-normal min-w-[120px]
//                   ${getTooltipPositionClasses(tooltipPosition)}
//                   ${tooltipOffset ? `m-${tooltipOffset}` : ''}
//                 `}
//                 style={{
//                   width: tooltipWidth || undefined
//                 }}
//               >
//                 {infoText}
//               </div>}
//             </div>
//           )}</div>}
//       <div className="mt-3">{children}</div>
//     </div>
//   );
// };
// const getTooltipPositionClasses = (position) => {
//   switch(position) {
//     case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
//     case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
//     case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
//     case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
//     default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
//   }
// };
// export default PageSection;
